import { apiClient } from "../config/api.config";
import { Patient } from "../types/patient.definition";
import { KeywordSearchRequest, SearchRequest } from "../types/search.definition";
export function searchPatientByPhoneNumberNameOrEmail(
  query: KeywordSearchRequest
) {
  return apiClient.request({
    method: "post",
    url: `/patients/search-by-phone-number-name-or-email`,
    data: query,
  });
}

export function getPatientById(patientId: string) {
  return apiClient.request({
    method: "get",
    url: `/patients/${patientId}`,
  });
}

export function getPatientPublic(patientId: string) {
  return apiClient.request({
    method: "get",
    url: `/patients/${patientId}/public`,
  });
}

export function searchPatients(query: SearchRequest) {
  return apiClient.request({
    method: "post",
    url: `/patients/search`,
    data: query,
  });
}

export function searchPatientsPublic(query: SearchRequest) {
  return apiClient.request({
    method: "post",
    url: `/patients/search/public`,
    data: query,
  });
}

// MED-1687: registration by the facility staff. No password: the patient gets a temporary one
// by SMS or email and an active account.
export function createPatient(facilityId: string | number, patientData: Partial<Patient>) {
  return apiClient.request({
    method: "post",
    url: `/healthcare-facilities/${facilityId}/patients`,
    data: patientData,
  });
}

export function updatePatient(
  patientId: string,
  patientData: Partial<Patient>
) {
  return apiClient.request({
    method: "put",
    url: `/patients/${patientId}`,
    data: patientData,
  });
}

export function getPatientAppointments(patientId: string) {
  return apiClient.request({
    method: "get",
    url: `/patients/${patientId}/appointments`,
  });
}
